module.exports = __webpack_public_path__ + "7e9ed175f530832fd80f70e443963bd8.png";


//////////////////
// WEBPACK FOOTER
// ./img/ArtsApp_symbol075.png
// module id = 123
// module chunks = 0